import EchartsTool from './echartsTool.js'

/**
 * 范围框整个X轴
 * Y轴 - 8AM 8PM
 * 浮窗 - 数值
 */
export default function getEchartsOptionLineC1(
	xAxis_data,
	series_data,
	expansion_data,
	markArea_range, 
	isDifferentColors,
	colorArr
) {
	
	// pieces
	let pieces = isDifferentColors ? EchartsTool.get_line_visual_map_pieces_1( xAxis_data, colorArr) :  EchartsTool.get_line_visual_map_pieces_2( xAxis_data, colorArr);


	// markArea_data
	let xRange = null;
	let yRange = null;
	if (markArea_range && markArea_range.length == 2) {
		let start = markArea_range[0];
		let startArr = start.split(":");
		let startMintues = parseInt(startArr[0]) * 60 + parseInt(startArr[1]);
		if ((startMintues > 480 && startMintues < 850) || (startMintues >= 850 && startMintues < 1200)) {
			if (startMintues > 480 && startMintues < 850) {
				xRange = '08:00'
			}
			if (startMintues >= 850 && startMintues < 1200) {
				xRange = '20:00'
			}
		} else {
			xRange = start;
		}

		let end = markArea_range[1];
		let endArr = end.split(":");
		let endMintues = parseInt(endArr[0]) * 60 + parseInt(endArr[1]);
		if ((endMintues > 480 && endMintues < 850) || (endMintues >= 850 && endMintues < 1200)) {
			if (endMintues > 480 && endMintues < 850) {
				yRange = '08:00'
			}
			if (endMintues >= 850 && endMintues < 1200) {
				yRange = '20:00'
			}
		} else {
			yRange = end;
		}
		
	}
	let markArea_data = (xRange && yRange) ? [
		[
			{ yAxis: xRange },
			{ yAxis: yRange },
		]
	] : undefined;

	let markLine_data = (xRange && yRange) ? [
		{
			yAxis: xRange
		},
		{
			yAxis: yRange
		}
	] : undefined

	// option
	let option = {
		grid: {
			x: 15,
			y: 15,
			x2: 15,
			y2: 10,
			containLabel: true
		},
		tooltip: {
			trigger: "axis",
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			borderColor: "#D8E2F8",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
				fontSize: 14
			},
			confine: true,
			formatter: function (val) {
				// 获取日期
				let date = expansion_data[val[0].dataIndex] || '';

				// 获取数值
				let value = val[0].value;

				// 区分颜色
				let dotColor = 'rgba(74, 124, 232, 1)';
				let textColor = 'rgba(131, 148, 185, 1)';
				if (EchartsTool.get_deal_color_arr_1(xAxis_data, colorArr)[val[0].dataIndex] == 1) {
					dotColor = 'rgba(255, 113, 134, 1)';
					textColor = 'rgba(255, 113, 134, 1)';
				}

				// 弹窗样式
				let titleDiv = `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${date}</div>`
				let contentDiv = `
				<div style="display: flex; align-items: center; margin-top: 5px;">
					<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
					<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${value}</div>
				</div>
				`
				return titleDiv + contentDiv;
			}
		},
		color: ["#988EE5"],
		xAxis: {
			type: 'category',
			data: xAxis_data,
			axisTick: {
				show: false,
			},
			axisLabel: {
				textStyle: {
					color: "#A5A9BC", //坐标的字体颜色
					fontSize: 10
				}
			},
			axisLine: {
				lineStyle: {
					color: "rgba(144, 148, 166, 0.1)",
					type: "solid",
				},
			},
		},
		yAxis: {
			axisLine: {
				show: false,
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				show: true,
				textStyle: {
					color: "#A5A9BC",
					fontSize: 10
				},
				formatter: function(value) {
					if (value == '20:00') {
						return '8PM'
					} else if (value == '00:00') {
						return '0AM'
					} else if (value == '04:00') {
						return '4AM'
					} else if (value == '08:00') {
						return '8AM'
					} else {
						return
					}
				},
				interval: 0
			},
			axisTick: {
				show: false,
			},
			splitLine: {
				show: 'auto',
				interval: function(index, value) {
					if (value == '20:00') {
						return true
					} else if (value == '00:00') {
						return true
					} else if (value == '04:00') {
						return true
					} else if (value == '08:00') {
						return true
					} else {
						return false
					}
				},
			},
			// max: 100
			data: [
				"20:00",
				"20:01",
				"20:02",
				"20:03",
				"20:04",
				"20:05",
				"20:06",
				"20:07",
				"20:08",
				"20:09",
				"20:10",
				"20:11",
				"20:12",
				"20:13",
				"20:14",
				"20:15",
				"20:16",
				"20:17",
				"20:18",
				"20:19",
				"20:20",
				"20:21",
				"20:22",
				"20:23",
				"20:24",
				"20:25",
				"20:26",
				"20:27",
				"20:28",
				"20:29",
				"20:30",
				"20:31",
				"20:32",
				"20:33",
				"20:34",
				"20:35",
				"20:36",
				"20:37",
				"20:38",
				"20:39",
				"20:40",
				"20:41",
				"20:42",
				"20:43",
				"20:44",
				"20:45",
				"20:46",
				"20:47",
				"20:48",
				"20:49",
				"20:50",
				"20:51",
				"20:52",
				"20:53",
				"20:54",
				"20:55",
				"20:56",
				"20:57",
				"20:58",
				"20:59",
				"21:00",
				"21:01",
				"21:02",
				"21:03",
				"21:04",
				"21:05",
				"21:06",
				"21:07",
				"21:08",
				"21:09",
				"21:10",
				"21:11",
				"21:12",
				"21:13",
				"21:14",
				"21:15",
				"21:16",
				"21:17",
				"21:18",
				"21:19",
				"21:20",
				"21:21",
				"21:22",
				"21:23",
				"21:24",
				"21:25",
				"21:26",
				"21:27",
				"21:28",
				"21:29",
				"21:30",
				"21:31",
				"21:32",
				"21:33",
				"21:34",
				"21:35",
				"21:36",
				"21:37",
				"21:38",
				"21:39",
				"21:40",
				"21:41",
				"21:42",
				"21:43",
				"21:44",
				"21:45",
				"21:46",
				"21:47",
				"21:48",
				"21:49",
				"21:50",
				"21:51",
				"21:52",
				"21:53",
				"21:54",
				"21:55",
				"21:56",
				"21:57",
				"21:58",
				"21:59",
				"22:00",
				"22:01",
				"22:02",
				"22:03",
				"22:04",
				"22:05",
				"22:06",
				"22:07",
				"22:08",
				"22:09",
				"22:10",
				"22:11",
				"22:12",
				"22:13",
				"22:14",
				"22:15",
				"22:16",
				"22:17",
				"22:18",
				"22:19",
				"22:20",
				"22:21",
				"22:22",
				"22:23",
				"22:24",
				"22:25",
				"22:26",
				"22:27",
				"22:28",
				"22:29",
				"22:30",
				"22:31",
				"22:32",
				"22:33",
				"22:34",
				"22:35",
				"22:36",
				"22:37",
				"22:38",
				"22:39",
				"22:40",
				"22:41",
				"22:42",
				"22:43",
				"22:44",
				"22:45",
				"22:46",
				"22:47",
				"22:48",
				"22:49",
				"22:50",
				"22:51",
				"22:52",
				"22:53",
				"22:54",
				"22:55",
				"22:56",
				"22:57",
				"22:58",
				"22:59",
				"23:00",
				"23:01",
				"23:02",
				"23:03",
				"23:04",
				"23:05",
				"23:06",
				"23:07",
				"23:08",
				"23:09",
				"23:10",
				"23:11",
				"23:12",
				"23:13",
				"23:14",
				"23:15",
				"23:16",
				"23:17",
				"23:18",
				"23:19",
				"23:20",
				"23:21",
				"23:22",
				"23:23",
				"23:24",
				"23:25",
				"23:26",
				"23:27",
				"23:28",
				"23:29",
				"23:30",
				"23:31",
				"23:32",
				"23:33",
				"23:34",
				"23:35",
				"23:36",
				"23:37",
				"23:38",
				"23:39",
				"23:40",
				"23:41",
				"23:42",
				"23:43",
				"23:44",
				"23:45",
				"23:46",
				"23:47",
				"23:48",
				"23:49",
				"23:50",
				"23:51",
				"23:52",
				"23:53",
				"23:54",
				"23:55",
				"23:56",
				"23:57",
				"23:58",
				"23:59",
				"00:00",
				"00:01",
				"00:02",
				"00:03",
				"00:04",
				"00:05",
				"00:06",
				"00:07",
				"00:08",
				"00:09",
				"00:10",
				"00:11",
				"00:12",
				"00:13",
				"00:14",
				"00:15",
				"00:16",
				"00:17",
				"00:18",
				"00:19",
				"00:20",
				"00:21",
				"00:22",
				"00:23",
				"00:24",
				"00:25",
				"00:26",
				"00:27",
				"00:28",
				"00:29",
				"00:30",
				"00:31",
				"00:32",
				"00:33",
				"00:34",
				"00:35",
				"00:36",
				"00:37",
				"00:38",
				"00:39",
				"00:40",
				"00:41",
				"00:42",
				"00:43",
				"00:44",
				"00:45",
				"00:46",
				"00:47",
				"00:48",
				"00:49",
				"00:50",
				"00:51",
				"00:52",
				"00:53",
				"00:54",
				"00:55",
				"00:56",
				"00:57",
				"00:58",
				"00:59",
				"01:00",
				"01:01",
				"01:02",
				"01:03",
				"01:04",
				"01:05",
				"01:06",
				"01:07",
				"01:08",
				"01:09",
				"01:10",
				"01:11",
				"01:12",
				"01:13",
				"01:14",
				"01:15",
				"01:16",
				"01:17",
				"01:18",
				"01:19",
				"01:20",
				"01:21",
				"01:22",
				"01:23",
				"01:24",
				"01:25",
				"01:26",
				"01:27",
				"01:28",
				"01:29",
				"01:30",
				"01:31",
				"01:32",
				"01:33",
				"01:34",
				"01:35",
				"01:36",
				"01:37",
				"01:38",
				"01:39",
				"01:40",
				"01:41",
				"01:42",
				"01:43",
				"01:44",
				"01:45",
				"01:46",
				"01:47",
				"01:48",
				"01:49",
				"01:50",
				"01:51",
				"01:52",
				"01:53",
				"01:54",
				"01:55",
				"01:56",
				"01:57",
				"01:58",
				"01:59",
				"02:00",
				"02:01",
				"02:02",
				"02:03",
				"02:04",
				"02:05",
				"02:06",
				"02:07",
				"02:08",
				"02:09",
				"02:10",
				"02:11",
				"02:12",
				"02:13",
				"02:14",
				"02:15",
				"02:16",
				"02:17",
				"02:18",
				"02:19",
				"02:20",
				"02:21",
				"02:22",
				"02:23",
				"02:24",
				"02:25",
				"02:26",
				"02:27",
				"02:28",
				"02:29",
				"02:30",
				"02:31",
				"02:32",
				"02:33",
				"02:34",
				"02:35",
				"02:36",
				"02:37",
				"02:38",
				"02:39",
				"02:40",
				"02:41",
				"02:42",
				"02:43",
				"02:44",
				"02:45",
				"02:46",
				"02:47",
				"02:48",
				"02:49",
				"02:50",
				"02:51",
				"02:52",
				"02:53",
				"02:54",
				"02:55",
				"02:56",
				"02:57",
				"02:58",
				"02:59",
				"03:00",
				"03:01",
				"03:02",
				"03:03",
				"03:04",
				"03:05",
				"03:06",
				"03:07",
				"03:08",
				"03:09",
				"03:10",
				"03:11",
				"03:12",
				"03:13",
				"03:14",
				"03:15",
				"03:16",
				"03:17",
				"03:18",
				"03:19",
				"03:20",
				"03:21",
				"03:22",
				"03:23",
				"03:24",
				"03:25",
				"03:26",
				"03:27",
				"03:28",
				"03:29",
				"03:30",
				"03:31",
				"03:32",
				"03:33",
				"03:34",
				"03:35",
				"03:36",
				"03:37",
				"03:38",
				"03:39",
				"03:40",
				"03:41",
				"03:42",
				"03:43",
				"03:44",
				"03:45",
				"03:46",
				"03:47",
				"03:48",
				"03:49",
				"03:50",
				"03:51",
				"03:52",
				"03:53",
				"03:54",
				"03:55",
				"03:56",
				"03:57",
				"03:58",
				"03:59",
				"04:00",
				"04:01",
				"04:02",
				"04:03",
				"04:04",
				"04:05",
				"04:06",
				"04:07",
				"04:08",
				"04:09",
				"04:10",
				"04:11",
				"04:12",
				"04:13",
				"04:14",
				"04:15",
				"04:16",
				"04:17",
				"04:18",
				"04:19",
				"04:20",
				"04:21",
				"04:22",
				"04:23",
				"04:24",
				"04:25",
				"04:26",
				"04:27",
				"04:28",
				"04:29",
				"04:30",
				"04:31",
				"04:32",
				"04:33",
				"04:34",
				"04:35",
				"04:36",
				"04:37",
				"04:38",
				"04:39",
				"04:40",
				"04:41",
				"04:42",
				"04:43",
				"04:44",
				"04:45",
				"04:46",
				"04:47",
				"04:48",
				"04:49",
				"04:50",
				"04:51",
				"04:52",
				"04:53",
				"04:54",
				"04:55",
				"04:56",
				"04:57",
				"04:58",
				"04:59",
				"05:00",
				"05:01",
				"05:02",
				"05:03",
				"05:04",
				"05:05",
				"05:06",
				"05:07",
				"05:08",
				"05:09",
				"05:10",
				"05:11",
				"05:12",
				"05:13",
				"05:14",
				"05:15",
				"05:16",
				"05:17",
				"05:18",
				"05:19",
				"05:20",
				"05:21",
				"05:22",
				"05:23",
				"05:24",
				"05:25",
				"05:26",
				"05:27",
				"05:28",
				"05:29",
				"05:30",
				"05:31",
				"05:32",
				"05:33",
				"05:34",
				"05:35",
				"05:36",
				"05:37",
				"05:38",
				"05:39",
				"05:40",
				"05:41",
				"05:42",
				"05:43",
				"05:44",
				"05:45",
				"05:46",
				"05:47",
				"05:48",
				"05:49",
				"05:50",
				"05:51",
				"05:52",
				"05:53",
				"05:54",
				"05:55",
				"05:56",
				"05:57",
				"05:58",
				"05:59",
				"06:00",
				"06:01",
				"06:02",
				"06:03",
				"06:04",
				"06:05",
				"06:06",
				"06:07",
				"06:08",
				"06:09",
				"06:10",
				"06:11",
				"06:12",
				"06:13",
				"06:14",
				"06:15",
				"06:16",
				"06:17",
				"06:18",
				"06:19",
				"06:20",
				"06:21",
				"06:22",
				"06:23",
				"06:24",
				"06:25",
				"06:26",
				"06:27",
				"06:28",
				"06:29",
				"06:30",
				"06:31",
				"06:32",
				"06:33",
				"06:34",
				"06:35",
				"06:36",
				"06:37",
				"06:38",
				"06:39",
				"06:40",
				"06:41",
				"06:42",
				"06:43",
				"06:44",
				"06:45",
				"06:46",
				"06:47",
				"06:48",
				"06:49",
				"06:50",
				"06:51",
				"06:52",
				"06:53",
				"06:54",
				"06:55",
				"06:56",
				"06:57",
				"06:58",
				"06:59",
				"07:00",
				"07:01",
				"07:02",
				"07:03",
				"07:04",
				"07:05",
				"07:06",
				"07:07",
				"07:08",
				"07:09",
				"07:10",
				"07:11",
				"07:12",
				"07:13",
				"07:14",
				"07:15",
				"07:16",
				"07:17",
				"07:18",
				"07:19",
				"07:20",
				"07:21",
				"07:22",
				"07:23",
				"07:24",
				"07:25",
				"07:26",
				"07:27",
				"07:28",
				"07:29",
				"07:30",
				"07:31",
				"07:32",
				"07:33",
				"07:34",
				"07:35",
				"07:36",
				"07:37",
				"07:38",
				"07:39",
				"07:40",
				"07:41",
				"07:42",
				"07:43",
				"07:44",
				"07:45",
				"07:46",
				"07:47",
				"07:48",
				"07:49",
				"07:50",
				"07:51",
				"07:52",
				"07:53",
				"07:54",
				"07:55",
				"07:56",
				"07:57",
				"07:58",
				"07:59",
				"08:00"
			]
		},
		visualMap: {
			show: false,
			dimension: 0,
			pieces: pieces
		},
		series: [
			{
				data: series_data,
				type: 'line',
				symbol: 'circle',
				symbolSize: 7.5,
				itemStyle: {
					normal: {
						color: 'rgba(74, 124, 232, 1)', // 中心圆点及hover时提示框中数值前面的圆点的颜色
						borderWidth: 1.5,
						borderColor: '#FFFFFF'
					}
				},
				markArea: {
					itemStyle: {
						color: 'rgba(74, 124, 232, 0.05)',
						lineStyle: {
							type: "dashed",
							color: "#8287F4",
						},
						// borderColor: "#9EB8F1",
						// borderWidth: 1.8,
						// borderType: 'dotted',
					},
					data: markArea_data,
				},
				markLine: {
					zIndex: -1,
					symbol: ['none', 'none'],
					label: {
					  show: false
					},
					lineStyle: {
						color: '#9EB8F1'
					},
					emphasis: {
                        disabled: true // 关闭高亮
                    },
					data: markLine_data
			  	},
				emphasis: {
					scale: 1.5
				}
			}
		]
	};
	return option;
}